import React from 'react'
import s from './GeoentityFuelListItem.less'

const GeoentityOpeningMessage = ({ openingMessage, openingMessageColor }) => {
  if (!openingMessage) return <></>

  return (
    <div className={s.openingMessage} style={{ color: openingMessageColor }}>
      {openingMessage}
    </div>
  )
}

export default GeoentityOpeningMessage
